import { render, staticRenderFns } from "./fortuneWheel.vue?vue&type=template&id=221af326&scoped=true"
import script from "./fortuneWheel.vue?vue&type=script&lang=js"
export * from "./fortuneWheel.vue?vue&type=script&lang=js"
import style0 from "./fortuneWheel.vue?vue&type=style&index=0&id=221af326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221af326",
  null
  
)

export default component.exports